<div class="outer" [ngStyle]="outerStyles">
  <div class="scroll-view" [ngClass]="{'scroll-view--disabled': restrictOverflow}">
    <div class="block">
      <div class="header">
        <ng-content select="ms-speed-reading-header"></ng-content>
      </div>
      <div class="content">
        <div class="parent">
          <ng-content></ng-content>
        </div>
      </div>
      <div class="footer">
        <ng-content select="ms-speed-reading-footer"></ng-content>
      </div>
    </div>
  </div>

  @if (isAnswer) {
    <div class="background-heroes">
      <div
        class="background-teacher"
        [bgUrl]="isCorrect ? theme.teacher.correct : theme.teacher.wrong"
        msHideOnNarrowWidth
      ></div>

      <div
        class="background-student"
        [bgUrl]="isCorrect ? theme.hero.fullCorrect : theme.hero.fullWrong"
        msHideOnNarrowWidth
      ></div>
    </div>
  }
</div>
